module.exports = __webpack_public_path__ + "fonts/brandon_med-webfont.8080379898a0808e69295f0232c1797f.eot";